type Props = {
	width?: string;
	height?: string;
	color?: string;
}

export const DownloadIcon = ({width, height, color}: Props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width || "22"} height={height || "22"} viewBox="0 0 22 22" fill="none">
  <path d="M19.25 19.25H2.75M16.5 10.0833L11 15.5833M11 15.5833L5.5 10.0833M11 15.5833V2.75" stroke={color || "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
)
